// extracted by mini-css-extract-plugin
export default {"off":"Duw5jCifHU8V0JSpQERh"};